"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var EstateAction;
(function (EstateAction) {
    EstateAction.ESTATE_ON_CHART_RANGE_CLICK = 'ESTATE_ON_CHART_RANGE_CLICK';
    EstateAction.ESTATE_ON_LOCATION_LABEL_CLICK = 'ESTATE_ON_LOCATION_LABEL_CLICK';
    EstateAction.ESTATE_ON_SELECT_BLOCK = 'ESTATE_ON_SELECT_BLOCK';
    EstateAction.ESTATE_FULL_SIZE = 'ESTATE_FULL_SIZE';
    EstateAction.ESTATE_SET_FULL_GALLERY_WIDTH = 'ESTATE_SET_FULL_GALLERY_WIDTH';
    EstateAction.ESTATE_SHOW_POP = 'ESTATE_SHOW_POP';
    EstateAction.ESTATE_SET_GALLERY_INDEX = 'ESTATE_SET_GALLERY_INDEX';
    EstateAction.ESTATE_ON_IMAGE_CLICK = 'ESTATE_ON_IMAGE_CLICK';
    EstateAction.ESTATE_SET_CHART_ACTIVE_INDEX = 'ESTATE_SET_CHART_ACTIVE_INDEX';
    EstateAction.ESTATE_ON_SELECT_PHASE = 'ESTATE_ON_SELECT_PHASE';
    EstateAction.ESTATE_ON_CONTACT_CLICK = 'ESTATE_ON_CONTACT_CLICK';
    EstateAction.ESTATE_SET_STICKY = 'ESTATE_SET_STICKY';
    EstateAction.onChartRangeClick = typesafe_actions_1.createAction(EstateAction.ESTATE_ON_CHART_RANGE_CLICK, function (resolve) { return function (i) { return resolve(i); }; });
    EstateAction.setChartActiveIndex = typesafe_actions_1.createAction(EstateAction.ESTATE_SET_CHART_ACTIVE_INDEX, function (resolve) { return function (i) { return resolve(i); }; });
    EstateAction.onLocationLabelClick = typesafe_actions_1.createAction(EstateAction.ESTATE_ON_LOCATION_LABEL_CLICK, function (resolve) { return function (phase, i) { return resolve({ phase: phase, i: i }); }; });
    EstateAction.onSelectBlock = typesafe_actions_1.createAction(EstateAction.ESTATE_ON_SELECT_BLOCK, function (resolve) { return function (block) { return resolve(block); }; });
    EstateAction.fullsize = typesafe_actions_1.createAction(EstateAction.ESTATE_FULL_SIZE, function (resolve) {
        return function (index) {
            return resolve(index);
        };
    });
    EstateAction.setFullGalleryWidth = typesafe_actions_1.createAction(EstateAction.ESTATE_SET_FULL_GALLERY_WIDTH, function (resolve) {
        return function (width) { return resolve(width); };
    });
    EstateAction.showPop = typesafe_actions_1.createAction(EstateAction.ESTATE_SHOW_POP, function (resolve) {
        return function (popState) {
            return resolve(popState);
        };
    });
    EstateAction.setGalleryIndex = typesafe_actions_1.createAction(EstateAction.ESTATE_SET_GALLERY_INDEX, function (resolve) {
        return function (i) { return resolve(i); };
    });
    EstateAction.onImageClick = typesafe_actions_1.createAction(EstateAction.ESTATE_ON_IMAGE_CLICK, function (resolve) {
        return function (src) { return resolve(src); };
    });
    EstateAction.onSelectPhase = typesafe_actions_1.createAction(EstateAction.ESTATE_ON_SELECT_PHASE, function (resolve) {
        return function (phaseId) { return resolve(phaseId); };
    });
    EstateAction.onContactClicked = typesafe_actions_1.createAction(EstateAction.ESTATE_ON_CONTACT_CLICK, function (resolve) {
        return function () { return resolve(); };
    });
    EstateAction.setSticky = typesafe_actions_1.createAction(EstateAction.ESTATE_SET_STICKY, function (resolve) {
        return function (isSticky) { return resolve(isSticky); };
    });
})(EstateAction || (EstateAction = {}));
exports.default = EstateAction;
